import { render, staticRenderFns } from "./recipes-hub-page.vue?vue&type=template&id=cfb8256e"
import script from "./recipes-hub-page.vue?vue&type=script&lang=js"
export * from "./recipes-hub-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports